import React from "react";
import { useAppReviewDemo } from "../../features/admin/hooks/useAppReviewDemo";
import { AppReviewDemoStatus } from "../../features/admin/models/AppReviewDemoStatus";
import { formatAdminTimestamp } from "../../features/admin/utils/formatAdminTimestamp";
import AppReviewDemoModal from "./AppReviewDemoModal";

const statusLine = (status: AppReviewDemoStatus | null): string => {
  if (status === null) return "Status unavailable.";
  if (!status.accountsConfigured) return "No demo addresses are configured on this server (AppReview:DemoAccounts).";
  if (!status.prepared || !status.preparedAt) return "Not prepared yet.";
  return `Prepared ${formatAdminTimestamp(status.preparedAt)} · ${status.memberCount} members · ${status.sessionCount} sessions · ${status.paymentCount} payments`;
};

/** The App Review demo school in the back office: its status line and the one action (PD-0053). */
const AppReviewDemoPanel: React.FC = () => {
  const { status, busy, confirmOpen, openConfirm, closeConfirm, prepare } = useAppReviewDemo();

  return (
    <div className="with-border rounded-2xl p-4 lg:p-6">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h2 className="text-lg font-bold text-grey-20 dark:text-white">App Review demo</h2>
          <p className="text-sm text-grey-40 dark:text-grey-70">{statusLine(status)}</p>
        </div>
        <button
          type="button"
          className="btn btn-secondary"
          disabled={busy || !status?.accountsConfigured}
          onClick={openConfirm}
        >
          Prepare App Review demo
        </button>
      </div>
      {status && status.issues.length > 0 && (
        <ul className="mt-2 list-disc pl-5 text-sm text-grey-40 dark:text-grey-70">
          {status.issues.map((issue) => (
            <li key={issue}>{issue}</li>
          ))}
        </ul>
      )}
      {confirmOpen && <AppReviewDemoModal busy={busy} onApply={prepare} onClose={closeConfirm} />}
    </div>
  );
};

export default AppReviewDemoPanel;
